import React from "react";

export const IconLinkInteraxo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="2" fill="black" />
      <path
        d="M13.9519 6.26343L4.89226 15.9586H7.50226C8.71252 15.9586 9.18039 15.6896 10.0891 14.771L18.0776 6.26343H13.948H13.9519Z"
        fill="url(#paint0_linear_28038_28641)"
      />
      <path
        d="M10.6961 6.26343L18.4411 14.5517H14.3231L6.57039 6.26343H10.6961Z"
        fill="url(#paint1_linear_28038_28641)"
      />
      <path
        d="M2.96666 4.97241L6.05226 4V13.0993C6.05226 15.4166 7.71106 15.9545 7.71106 15.9545H4.81106C3.79026 15.9545 2.96666 15.069 2.96666 13.9807V4.97241Z"
        fill="url(#paint2_linear_28038_28641)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28038_28641"
          x1="6.65932"
          y1="16.2938"
          x2="17.6895"
          y2="5.94428"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.05" stop-color="#353449" />
          <stop offset="0.31" stop-color="#2F5177" />
          <stop offset="1" stop-color="#40B1DA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28038_28641"
          x1="16.7552"
          y1="14.9696"
          x2="7.18296"
          y2="5.99019"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stop-color="#283D67" />
          <stop offset="0.29" stop-color="#007294" />
          <stop offset="0.5" stop-color="#37A7D5" />
          <stop offset="0.89" stop-color="#ADDCEB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_28038_28641"
          x1="2.78879"
          y1="15.0069"
          x2="9.1634"
          y2="5.09365"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stop-color="#2D4371" />
          <stop offset="0.24" stop-color="#007294" />
          <stop offset="0.49" stop-color="#37A7D5" />
          <stop offset="0.8" stop-color="#ADDCEB" />
        </linearGradient>
      </defs>
    </svg>
  );
};
